import { render, staticRenderFns } from "./SensorStatus.vue?vue&type=template&id=0aa8d97e&scoped=true"
import script from "./SensorStatus.vue?vue&type=script&lang=js"
export * from "./SensorStatus.vue?vue&type=script&lang=js"
import style0 from "./SensorStatus.vue?vue&type=style&index=0&id=0aa8d97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8d97e",
  null
  
)

export default component.exports